import { render } from "./ranking.vue?vue&type=template&id=8fc24f30&scoped=true"
import script from "./ranking.vue?vue&type=script&lang=js"
export * from "./ranking.vue?vue&type=script&lang=js"

import "./ranking.vue?vue&type=style&index=0&id=8fc24f30&lang=less&scoped=true"

import exportComponent from "E:\\suooter\\36live\\live\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fc24f30"]])

export default __exports__